import React, { useEffect, useState } from "react";
import { API } from "../../Redux/actions/API";
import { useNavigate } from "react-router-dom";
import Table from "../Table/Table";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import { toast } from "react-toastify";

export default function UsdtQrDetails() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [imglink, setimglink] = useState("");
  const [upiid, setupiid] = useState("");
  const [upiName, setupiName] = useState("");
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);

  const referral_API = async () => {
    try {
      let responceRight = await API?.post(
        "/adminBankDetailsByBankidAdmin",
        {
          loginid: userId,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      //console.log("ewalletDetails", responceRight?.data?.data[0]);
      //   console.log("response", responceRight);
      responceRight = responceRight?.data?.data[0];
      setleftreferralApi([]);
      let arrayLeft = [];

      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          imglink: <img src={`${item?.imglink}`} width={300} />,
          btcaddress: `${item?.btcaddress}`,
          btcname: item.Bank_Name,
          edate: `${item?.edate}`,
          status: parseInt(item.status) === 0 ? "InActive" : "Active",
          delete: (
            <>
              <input
                type="button"
                id="btnsearch"
                onClick={() => DeleteUPI_API(item.id)}
                className="btn btn-sm btn-primary"
                value="Delete"
              />
            </>
          ),
        });
      });
      setleftreferralApi(arrayLeft);
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const OnhandleSubmit_API = async () => {
    try {
      let responceRight = await API?.post(
        `updateDepositDetails`,
        {
          loginid: userId,
          upiId: upiid,
          imglink: imglink,
          upiName: upiName,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      console.log("submit", responceRight?.data?.data);
      //console.log("response", responceRight?.data?.data[0][0]);
      //responceRight = responceRight?.data?.data[0][0];
      if (responceRight?.data?.data == "Success") {
        toast.success("Updated Successfully !!");
        referral_API();
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        toast.error(responceRight?.data?.data);
      }
    } catch (e) {
      console.log("error directdeposite APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "" }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  const DeleteUPI_API = async (RowId) => {
    try {
      let responceRight = await API?.post(
        `DeleteDepositDetails`,
        {
          loginid: userId,
          id: RowId,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      console.log("submit", responceRight?.data?.data);

      if (responceRight?.data?.data == "Success") {
        toast.success("Deleted Successfully !!");
        referral_API();
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        toast.error(responceRight?.data?.data);
      }
    } catch (e) {
      console.log("error directdeposite APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "" }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;

  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost
  );

  var [my_team, set_my_team] = new useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "Upi Id", accessor: "btcaddress" },
      { Header: "Upi Name", accessor: "btcname" },
      { Header: "QR Code", accessor: "imglink" },
      { Header: "Date", accessor: "edate" },
      //{ Header: "Status", accessor: "status" },
      { Header: "Delete", accessor: "delete" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div className="content-page">
        <div className="content">
          {/* <!-- Inline Form --> */}
          <div className="row">
            <div className="col-md-12">
              <div className="panel panel-primary">
                <div className="panel-heading">
                  <h4 className="panel-title"> Update USDT QR Details</h4>
                </div>
                <div
                  className="panel-body table-rep-plugin"
                  style={{ padding: "8px", overflowY: "scroll" }}
                >
                  <div className="col-md-12">
                    <>
                      {" "}
                      <div className="row mb-5">
                        <form>
                          <div className="col-sm-3">
                            <input
                              className="form-control in-ip-1"
                              id="upiid"
                              onChange={(e) => setupiid(e.target.value)}
                              name="upiid"
                              placeholder="Upi Id"
                              type="text"
                              value={upiid}
                              maxLength={100}
                            />
                          </div>
                          <div className="col-sm-3">
                            <input
                              className="form-control in-ip-1"
                              id="upiid"
                              onChange={(e) => setupiName(e.target.value)}
                              name="upiid"
                              placeholder="Upi Name"
                              type="text"
                              value={upiName}
                              maxLength={100}
                            />
                          </div>
                          <div className="col-sm-4">
                            <input
                              className="form-control in-ip-1"
                              id="imglink"
                              onChange={(e) => setimglink(e.target.value)}
                              name="imglink"
                              placeholder="Enter Image Link"
                              type="text"
                              value={imglink}
                            />
                            <a
                              href="https://tools.atatus.net/tools/image-to-url"
                              target="_blank"
                            >
                              Generate Image Link
                            </a>
                          </div>

                          <div className="col-sm-1">
                            <input
                              type="button"
                              id="btnsearch"
                              onClick={() => OnhandleSubmit_API()}
                              className="btn btn-sm btn-primary"
                              value="Update"
                            />
                          </div>
                        </form>
                      </div>
                    </>
                    <div className="row panel panel-primary">
                      <div className="panel-heading">
                        <h4 className="panel-title"> USDT QR Details</h4>
                      </div>
                      <div
                        className="table-responsive"
                        data-pattern="priority-columns"
                        style={{ maxHeight: "500px", overflow: "scroll" }}
                      >
                        <Table data={currentPostleft} columns={my_team.cols} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
